import { render, staticRenderFns } from "./wxShareToast.vue?vue&type=template&id=130a1ed2&scoped=true&"
import script from "./wxShareToast.vue?vue&type=script&lang=js&"
export * from "./wxShareToast.vue?vue&type=script&lang=js&"
import style0 from "./wxShareToast.vue?vue&type=style&index=0&id=130a1ed2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130a1ed2",
  null
  
)

export default component.exports